import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/landing/Navbar';
import { Badge } from '../components/Badge';
type Post = {
  slug: string;
  category: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
};
const posts: Post[] = [{
  slug: '5-minute-rule',
  category: 'Research',
  title: 'The 5-Minute Rule: Why Speed Determines 78% of Deals',
  excerpt: 'A deep dive into the Harvard study of 1.25M leads — and what it really means for service businesses fighting for the first response.',
  date: 'May 6, 2026',
  readTime: '7 min read'
}, {
  slug: 'plumbing-case-study',
  category: 'Case Study',
  title: 'How a $2M Plumbing Company 3×’d Their Booked Jobs in 30 Days',
  excerpt: 'Before: 23-minute average response time and a 6% close rate. After: 12 seconds and 19%. Here is exactly what changed.',
  date: 'Apr 22, 2026',
  readTime: '5 min read'
}, {
  slug: 'ai-vs-human',
  category: 'Playbook',
  title: 'AI vs Human Reps: When Each One Wins (and When They Lose)',
  excerpt: 'A practical framework for deciding where AI belongs in your funnel — and the moments where a human still closes more.',
  date: 'Apr 9, 2026',
  readTime: '8 min read'
}, {
  slug: 'first-response-window',
  category: 'Research',
  title: 'The First-Response Window Is Shrinking. Here’s the Data.',
  excerpt: 'Buyer expectations have collapsed from hours to seconds over the last decade. We pulled four studies into one timeline.',
  date: 'Mar 28, 2026',
  readTime: '6 min read'
}, {
  slug: 'qualifying-questions',
  category: 'Playbook',
  title: 'The 7 Qualifying Questions Every Service Business Should Ask',
  excerpt: 'A field-tested script for separating tire-kickers from ready-to-buy leads — without sounding like an interrogation.',
  date: 'Mar 14, 2026',
  readTime: '4 min read'
}, {
  slug: 'hvac-case-study',
  category: 'Case Study',
  title: 'An HVAC Company Stopped Losing Nights & Weekends to Voicemail',
  excerpt: '63% of their inbound came after hours. Here’s how they captured it without hiring a single new rep.',
  date: 'Feb 26, 2026',
  readTime: '6 min read'
}];
function PostCard({
  post
}: {
  post: Post;
}) {
  return <a href="#" className="group flex flex-col border border-gray-300 rounded-2xl bg-white overflow-hidden hover:border-navy-500 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-navy-500 focus-visible:ring-offset-2" data-id="element-354">
      <div className="aspect-[16/9] bg-gray-100 border-b border-gray-200 flex items-center justify-center" data-id="element-355">
        <span className="italic text-sm text-gray-400" data-id="element-356">image</span>
      </div>

      <div className="flex flex-col gap-3 p-5 sm:p-6 flex-1" data-id="element-357">
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full bg-navy-50 text-navy-500 border border-navy-500/15 uppercase tracking-[0.15em] text-[10px] font-semibold" data-id="element-358">
          {post.category}
        </span>

        <h3 className="text-base sm:text-lg font-semibold text-gray-900 leading-snug group-hover:text-gray-700 transition-colors" data-id="element-359">
          {post.title}
        </h3>

        <p className="text-sm text-gray-600 leading-relaxed flex-1" data-id="element-360">
          {post.excerpt}
        </p>

        <div className="flex items-center gap-2 text-xs text-gray-500 pt-2 border-t border-gray-100" data-id="element-361">
          <span data-id="element-362">{post.date}</span>
          <span aria-hidden data-id="element-363">·</span>
          <span data-id="element-364">{post.readTime}</span>
          <span className="ml-auto text-gray-900 font-medium group-hover:translate-x-0.5 transition-transform" aria-hidden data-id="element-365">
            →
          </span>
        </div>
      </div>
    </a>;
}
export function BlogIndex() {
  return <>
      <Navbar data-id="element-366" />
      <main className="w-full bg-white text-gray-900" data-id="element-367">
        {/* Header */}
        <section className="w-full border-b border-gray-200 bg-white px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24" data-id="element-368">
          <div className="mx-auto max-w-[1280px] flex flex-col gap-4 max-w-2xl" data-id="element-369">
            <div className="text-[11px] uppercase tracking-[0.2em] text-gray-500 font-semibold" data-id="element-370">
              <Link to="/" className="text-navy-500 hover:text-navy-800 transition-colors" data-id="element-371">
                ← Back to home
              </Link>
            </div>
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-gray-900 tracking-tight leading-[1.1]" data-id="element-372">
              The Blog
            </h1>
            <p className="text-base text-gray-600 leading-relaxed max-w-xl" data-id="element-373">
              Research, case studies, and playbooks on speed-to-lead, AI sales,
              and the science of winning the first response.
            </p>
          </div>
        </section>

        {/* Posts */}
        <section className="w-full bg-gray-50 px-4 sm:px-6 lg:px-12 py-12 sm:py-20 lg:py-24" data-id="element-374">
          <div className="mx-auto max-w-[1280px]" data-id="element-375">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-376">
              {posts.map(post => <PostCard key={post.slug} post={post} data-id="element-377" />)}
            </div>
          </div>
        </section>
      </main>
    </>;
}